const _excluded = ["name", "size", "color", "viewBox"];
function cov_17iqqzwknt() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/Icon.tsx";
  var hash = "ebe11a27f312099ce5eea6779c540314782562af";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/Icon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 419,
          column: 34
        },
        end: {
          line: 455,
          column: 1
        }
      },
      "1": {
        start: {
          line: 429,
          column: 19
        },
        end: {
          line: 429,
          column: 31
        }
      },
      "2": {
        start: {
          line: 430,
          column: 2
        },
        end: {
          line: 432,
          column: 3
        }
      },
      "3": {
        start: {
          line: 431,
          column: 4
        },
        end: {
          line: 431,
          column: 23
        }
      },
      "4": {
        start: {
          line: 433,
          column: 2
        },
        end: {
          line: 435,
          column: 3
        }
      },
      "5": {
        start: {
          line: 434,
          column: 4
        },
        end: {
          line: 434,
          column: 26
        }
      },
      "6": {
        start: {
          line: 437,
          column: 29
        },
        end: {
          line: 437,
          column: 78
        }
      },
      "7": {
        start: {
          line: 439,
          column: 2
        },
        end: {
          line: 454,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 419,
            column: 34
          },
          end: {
            line: 419,
            column: 35
          }
        },
        loc: {
          start: {
            line: 427,
            column: 6
          },
          end: {
            line: 455,
            column: 1
          }
        },
        line: 427
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 421,
            column: 2
          },
          end: {
            line: 421,
            column: 11
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 421,
            column: 9
          },
          end: {
            line: 421,
            column: 11
          }
        }],
        line: 421
      },
      "1": {
        loc: {
          start: {
            line: 422,
            column: 9
          },
          end: {
            line: 422,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 422,
            column: 21
          },
          end: {
            line: 422,
            column: 34
          }
        }],
        line: 422
      },
      "2": {
        loc: {
          start: {
            line: 425,
            column: 2
          },
          end: {
            line: 425,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 425,
            column: 12
          },
          end: {
            line: 425,
            column: 23
          }
        }],
        line: 425
      },
      "3": {
        loc: {
          start: {
            line: 430,
            column: 2
          },
          end: {
            line: 432,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 430,
            column: 2
          },
          end: {
            line: 432,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 430
      },
      "4": {
        loc: {
          start: {
            line: 433,
            column: 2
          },
          end: {
            line: 435,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 433,
            column: 2
          },
          end: {
            line: 435,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 433
      },
      "5": {
        loc: {
          start: {
            line: 445,
            column: 15
          },
          end: {
            line: 445,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 445,
            column: 36
          },
          end: {
            line: 445,
            column: 57
          }
        }, {
          start: {
            line: 445,
            column: 60
          },
          end: {
            line: 445,
            column: 67
          }
        }],
        line: 445
      },
      "6": {
        loc: {
          start: {
            line: 448,
            column: 23
          },
          end: {
            line: 448,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 448,
            column: 39
          },
          end: {
            line: 448,
            column: 47
          }
        }, {
          start: {
            line: 448,
            column: 50
          },
          end: {
            line: 448,
            column: 59
          }
        }],
        line: 448
      },
      "7": {
        loc: {
          start: {
            line: 451,
            column: 7
          },
          end: {
            line: 451,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 451,
            column: 7
          },
          end: {
            line: 451,
            column: 23
          }
        }, {
          start: {
            line: 451,
            column: 27
          },
          end: {
            line: 451,
            column: 69
          }
        }],
        line: 451
      },
      "8": {
        loc: {
          start: {
            line: 452,
            column: 7
          },
          end: {
            line: 452,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 452,
            column: 28
          },
          end: {
            line: 452,
            column: 66
          }
        }, {
          start: {
            line: 452,
            column: 69
          },
          end: {
            line: 452,
            column: 99
          }
        }],
        line: 452
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ebe11a27f312099ce5eea6779c540314782562af"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17iqqzwknt = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_17iqqzwknt();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { bricks } from "../../system/bricks.types.mjs";
import { SIZE_SPECIFIC_ICONS_MANIFEST } from "./SpritesheetManifest.mjs";
/**
 * Icon references the named icons in the Spritesheet
 * `js/packages/bricks/src/components/ui/svg/Spritesheet.tsx`. The spritesheet
 * is injected once per page, each instance of Icon references the spritesheet
 * using an SVG `<use />` element.
 *
 * Most icons support dynamic colors some such as `favorite-selected` and
 * `jewel` do not.
 *
 * ###
 *
 * Using Icons in bundle sensitive apps
 *
 * If you are using an icon in a bundle sensitive app like Cosmos take note that
 * you might need to use`SelectiveSpritesheet` to load in the spritesheet for
 * your icon to appear. Link to code
 * [example](https://github.com/opendoor-labs/code/blob/9b96774f/js/packages/cosmos/src/components/shared/MenuPanel.tsx#L186)
 * of using SelectiveSpritesheet.
 *
 * **Example of using this for Icon:**
 *
 * ```
 * import SelectiveSpritesheet from '@opendoor/bricks/core/Icon/SelectiveSpritesheet';
 *
 * const Email: React.FC(){
 *      return (
 *      <Box>
 *        <SelectiveSpriteSheet icons={[Email]} />
 *        <Icon name="email" size={16} />
 *      </Box>
 *  )
 * }
 * ```
 *
 * ####
 *
 * Example of using this for a Bricks Component that uses an Icon:
 *
 * For bundle-sensitive apps that use `SelectiveSpritesheet` you also have to
 * import in the specific spritesheet for Bricks/Cinderblocks component if it
 * uses a specific icons
 *
 * ```
 * import SelectiveSpritesheet from '@opendoor/bricks/core/Icon/SelectiveSpritesheet';
 *
 * function showNewFAQS() {
 *    return(
 *        <Box>
 *          <H2>New FAQ</H2>
 *          <SelectiveSpriteSheet icons={[ChevronDown16]} />
 *          <List variant="accordion">
 *          <AccordionListItem>FAQ #1</AccordionListItem>
 *          </List>
 *        </Box>
 *    )
 * }
 * ```
 *
 * How to add Icons to Bricks
 *
 * ------------------------------
 *
 * _Please ensure you're adding icons to all pages in alphabetical order_
 *
 * 1.  Add your new icon names to the
 * [Spritesheet\_Icons\_Manifest](https://github.com/opendoor-labs/code/blob/master/js/packages/bricks/src/core/Icon/SpritesheetManifest.tsx)
 * - this is the source of truth for icons and will kick off typechecking.
 *
 * 2.  Get svgs from [Google Material Icons](https://fonts.google.com/icons) or
 * from your designer. Ensure your icons are on the approved icon list in this
 * [figma](https://www.figma.com/file/w3nEyANoniTZdjz8kCUaDS/Bricks-Design-System?type=design&node-id=26-651&mode=design&t=Mrq2xFtxK1KppCR2-0).
 * If they are not reach out to your designer and CPLAT to discuss (make sure
 * `fill="currentColor"` is included in the svg path otherwise the icon will not
 * show up).
 *
 * 3.  Create a new file in the folder
 * [SpriteSheetIcons](https://github.com/opendoor-labs/code/tree/master/js/packages/bricks/src/core/Icon/SpritesheetIcons).
 * Copy the same format as the code snippit below and update the name and svg to
 * match the icon you're adding. Ensure you update the fill to equal
 * currentColor in the svg path.
 *
 *
 * ``   const Icon: { name: 'icon-name'; svg: string } = {   name: 'icon-name',
 * svg: `<path fill-rule="evenodd" clip-rule="evenodd" d="M4.11612
 * 11.1161C3.62796 11.6043 3.62796 12.3957 4.11612 12.8839L11.1161
 * 19.8839C11.6043 20.372 12.3957 20.372 12.8839 19.8839L19.8839 12.8839C20.372
 * 12.3957 20.372 11.6043 19.8839 11.1161C19.3957 10.628 18.6043 10.628 18.1161
 * 11.1161L13.25 15.9822V5C13.25 4.30964 12.6904 3.75 12 3.75C11.3096 3.75 10.75
 * 4.30964 10.75 5L10.75 15.9822L5.88388 11.1161C5.39573 10.628 4.60427 10.628
 * 4.11612 11.1161Z" fill="currentColor"/>`, }; export default Icon;   ``
 *
 * 4.  Update
 * [SpriteSheet.tsx](https://github.com/opendoor-labs/code/blob/master/js/packages/bricks/src/core/Icon/Spritesheet.tsx)
 *
 * 1.
 * [Import](https://github.com/opendoor-labs/code/blob/master/js/packages/bricks/src/core/Icon/Spritesheet.tsx#L6)
 * the new icon you added to the spritesheetIcons folder into SpriteSheet.tsx
 *
 * 2.  Add your new icon to
 * [SPRITESHEET\_ICONS](https://github.com/opendoor-labs/code/blob/master/js/packages/bricks/src/core/Icon/Spritesheet.tsx#L6)
 *
 * 5.  Update the knapsack docs by including your icon in the
 * [enum](https://github.com/opendoor-labs/code/blob/deb4348e/js/packages/bricks-knapsack/data/knapsack.pattern.icon.json#L27)
 * list
 *
 * 6.  Your icons are ready to be used!
 *
 * Please refer to this [PR](https://github.com/opendoor-labs/code/pull/62489)
 * as an example
 *
 *
 * Icon variations
 * ---------------------------------------------------------------------------------------
 *
 * "360"
 *
 * "360-2"
 *
 * "arrow-down"
 *
 * "arrow-left"
 *
 * "arrow-right"
 *
 * "arrow-up"
 *
 * "avatar"
 *
 * "avatar-filled"
 *
 * "bathroom"
 *
 * "bathroom-filled"
 *
 * "bathroom-version-two"
 *
 * "bathroom-version-two-filled"
 *
 * "bedroom"
 *
 * "bedroom-filled"
 *
 * "center-focus-strong"
 *
 * "chat"
 *
 * "chat-inactive"
 *
 * "chat-2"
 *
 * "chat-2-filled"
 *
 * "checkmark"
 *
 * "chevron-down"
 *
 * "chevron-left"
 *
 * "chevron-right"
 *
 * "chevron-up"
 *
 * "close"
 *
 * "contact-phone"
 *
 * "date"
 *
 * "date-filled"
 *
 * "date-add"
 *
 * "date-add-filled"
 *
 * "date-checked"
 *
 * "date-checked-filled"
 *
 * "date-subtract"
 *
 * "date-subtract-filled"
 *
 * "document-check"
 *
 * "document-check-filled"
 *
 * "door"
 *
 * "door-filled"
 *
 * "double-chevron"
 *
 * "double-move"
 *
 * "early-access"
 *
 * "edit"
 *
 * "edit-filled"
 *
 * "email"
 *
 * "email-filled"
 *
 * "equal"
 *
 * "expertise"
 *
 * "favorite"
 *
 * "favorite-filled"
 *
 * "filter"
 *
 * "garage"
 *
 * "garage-filled"
 *
 * "geo"
 *
 * "geo-filled"
 *
 * "home"
 *
 * "home-filled"
 *
 * "home-chat"
 *
 * "home-chat-filled"
 *
 * "home-cost"
 *
 * "home-cost-filled"
 *
 * "home-location"
 *
 * "home-location-filled"
 *
 * "info"
 *
 * "info-filled"
 *
 * "invite"
 *
 * "invite-filled"
 *
 * "jewel"
 *
 * "levels"
 *
 * "levels-filled"
 *
 * "list"
 *
 * "live-help"
 *
 * "location"
 *
 * "location-pin"
 *
 * "location-pin-filled"
 *
 * "location-pin-home"
 *
 * "location-pin-home-filled"
 *
 * "lock"
 *
 * "lock-filled"
 *
 * "logo"
 *
 * "map"
 *
 * "menu"
 *
 * "minus"
 *
 * "money"
 *
 * "move"
 *
 * "move-filled"
 *
 * "multiple-offers"
 *
 * "multiple-ofers-filled"
 *
 * "neighborhood"
 *
 * "neighborhood-filled"
 *
 * "new"
 *
 * "new-construction"
 *
 * "new-tab"
 *
 * "new-tab-filled"
 *
 * "notification"
 *
 * "obo"
 *
 * "offer"
 *
 * "offer-inactive"
 *
 * "open"
 *
 * "pdf"
 *
 * "phone"
 *
 * "phone-filled"
 *
 * "photo-library"
 *
 * "placeholder"
 *
 * "plus"
 *
 * "popular"
 *
 * "question"
 *
 * "rate"
 *
 * "refresh"
 *
 * "refresh-filled"
 *
 * "reset"
 *
 * "search"
 *
 * "search-filled"
 *
 * "see"
 *
 * "see-filled"
 *
 * "see-hidden"
 *
 * "share"
 *
 * "share-filled"
 *
 * "shower"
 *
 * "shower-filled"
 *
 * "sign"
 *
 * "sign-filled"
 *
 * "sink"
 *
 * "sink-filled"
 *
 * "sink-version-two"
 *
 * "sink-version-two-filled"
 *
 * "sliders"
 *
 * "sliders-filled"
 *
 * "square-feet"
 *
 * "square-feet-filled"
 *
 * "star"
 *
 * "star-filled"
 *
 * "telephone"
 *
 * "trash"
 *
 * "trash-filled"
 *
 * "unlock-left"
 *
 * "unlock-left-filled"
 *
 * "unlock-right"
 *
 * "unlock-right-filled"
 *
 * "video"
 *
 * "video-filled"
 *
 * "warning"
 */
cov_17iqqzwknt().s[0]++;
const Icon = _ref => {
  let {
      name,
      size = (cov_17iqqzwknt().b[0][0]++, 24),
      color: colorName = (cov_17iqqzwknt().b[1][0]++, 'neutrals100'),
      // all of our icons assume a 0 0 24 24 viewBox, except non-standard icons e.g. early-access, popular
      // this prop should only be used for these non-standard icons
      viewBox = (cov_17iqqzwknt().b[2][0]++, '0 0 24 24')
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_17iqqzwknt().f[0]++;
  // Pass arbitrary styling props to the svg element, but remove `id` and `title` first
  const svgProps = (cov_17iqqzwknt().s[1]++, _objectSpread({}, props));
  cov_17iqqzwknt().s[2]++;
  if ('id' in svgProps) {
    cov_17iqqzwknt().b[3][0]++;
    cov_17iqqzwknt().s[3]++;
    delete svgProps.id;
  } else {
    cov_17iqqzwknt().b[3][1]++;
  }
  cov_17iqqzwknt().s[4]++;
  if ('title' in svgProps) {
    cov_17iqqzwknt().b[4][0]++;
    cov_17iqqzwknt().s[5]++;
    delete svgProps.title;
  } else {
    cov_17iqqzwknt().b[4][1]++;
  }
  const isSizeSpecificIcon = (cov_17iqqzwknt().s[6]++, "".concat(name, "-").concat(size) in SIZE_SPECIFIC_ICONS_MANIFEST);
  cov_17iqqzwknt().s[7]++;
  return /*#__PURE__*/React.createElement(bricks.svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "".concat(name, "-icon"),
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    viewBox: isSizeSpecificIcon ? (cov_17iqqzwknt().b[5][0]++, "0 0 ".concat(size, " ").concat(size)) : (cov_17iqqzwknt().b[5][1]++, viewBox),
    flexShrink: 0,
    color: colorName,
    "aria-labelledby": 'id' in props ? (cov_17iqqzwknt().b[6][0]++, props.id) : (cov_17iqqzwknt().b[6][1]++, undefined)
  }, svgProps), (cov_17iqqzwknt().b[7][0]++, 'title' in props) && (cov_17iqqzwknt().b[7][1]++, /*#__PURE__*/React.createElement("title", {
    id: props.id
  }, props.title)), isSizeSpecificIcon ? (cov_17iqqzwknt().b[8][0]++, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(name, "-").concat(size)
  })) : (cov_17iqqzwknt().b[8][1]++, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(name)
  })));
};
export default Icon;